import type { GameId, Lang } from "@shared/types";
import { ensureLocalContent, localContent } from "./local-content";
import { LocalRoom, type LocalSetup } from "./local-room";

const live = new Map<string, LocalRoom>();

export async function createLocal(setup: LocalSetup): Promise<LocalRoom> {
  await ensureLocalContent(setup.game, setup.lang);
  const room = new LocalRoom(localContent, { setup });
  live.set(room.code, room);
  return room;
}

export async function openLocal(code: string): Promise<LocalRoom | null> {
  const existing = live.get(code);
  if (existing) return existing;
  const peek = LocalRoom.saved().find((s) => s.code === code);
  if (!peek) return null;
  const raw = localStorage.getItem("hg:local:" + code);
  const lang = raw ? (JSON.parse(raw).lang as Lang) : "ka";
  await ensureLocalContent(peek.game as GameId, lang);
  const room = LocalRoom.restore(code, localContent);
  if (room) live.set(code, room);
  return room;
}

export function forgetLocal(code: string) {
  const r = live.get(code);
  r?.discard();
  live.delete(code);
}
